export const enum Category {
  APARTMENT = 'APARTMENT',
  DETACHED_HOUSE = 'DETACHED_HOUSE',
  SEMI_DETACHED_HOUSE = 'SEMI_DETACHED_HOUSE',
  CHAINED_HOUSE = 'CHAINED_HOUSE',
  CO_OP = 'CO_OP',
  DORM = 'DORM',
  COMMERCIAL = 'COMMERCIAL',
  GARAGE_PARKING = 'GARAGE_PARKING',
  OTHER = 'OTHER',
}
